const lbaCompanyReferenceConfigAuditItem = angular.module('app.lbaCompanyReferenceConfigAuditItem', []);

lbaCompanyReferenceConfigAuditItem.controller('lbaCompanyReferenceConfigAuditItemCtrl', require('./lbaCompanyReferenceConfigAuditItemCtrl'));
lbaCompanyReferenceConfigAuditItem.directive('lbaCompanyReferenceConfigAuditItem', require('./lbaCompanyReferenceConfigAuditItemDir'));

export default lbaCompanyReferenceConfigAuditItem;



// WEBPACK FOOTER //
// ./src/components/lbaCompanyReferenceConfigAuditItem/index.js